module.exports = __webpack_public_path__ + "static/media/edit_btn.1a7a794a.svg";